export default class SubscriptionAddController {
    constructor(userService, $location, notificationsService) {
        this.form = {};
        this.form.subscription = {}; //this could be nicer?
        this.userService = userService;
        this.$location = $location;
        this.notificationsService = notificationsService;
        this.imageData = {};
    }

    onSave(){
        //admin user type
        this.form.usertype = 2;

        var that = this;
        that.form.image = that.imageData.image;
        that.form.imagetype =  that.imageData.imagetype;
        that.userService.insertSubscriptionAdmin(that.form).then(resp => {
            that.$location.path("/subscriptions");
            that.notificationsService.show("Subscription added", "success");
        }, resp => {
            that.notificationsService.show(resp.data, "error");
        });
    }

    goBack(){
        this.$location.path("/subscriptions");
    }
}


// WEBPACK FOOTER //
// ./src/js/components/subscriptions/subscriptions.add.controller.js